import React, { useState, useMemo } from "react";
import { Row, Col } from "reactstrap";

import BulkRequestDestroyDocumentTable from "../../../../bulk/request/destroy_document/table";

import { create as createBulkRequestDestroyDocumentService } from "./axios";
import { fetchCustomFieldValue, isAuthorizedCustomFieldToUser } from "../../../../helper/custom_field/helper";

const LaboralBulkRequestDestroyDocumentForm = props => {
  const {
    currentCustomer,
    currentUser,
    data: {
      branches,
      companies,
      customFields,
      documentStates,
      documentTypes,
      securityLayers,
    }
  } = props;

  const [bulkRequest, setBulkRequest] = useState(props?.bulkRequest || {});
  const hiringStateOptions = [{ value: 'active', label: I18n.t('laboral.hirings.index.tabs.active') }, { value: 'expired', label: I18n.t('laboral.hirings.index.tabs.expired') }]

  const tableColumnsDefault = [
    {
      field: "entity.employee.employee_config.name",
      header: I18n.t("activerecord.attributes.laboral/employee_config.name"),
      body: (row) => row?.entity.employee?.employee_config?.name || I18n.t('no_entry'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el nombre del empleado',
        inputType: 'text',
        filterrific: {
          search: 'search_by_employee_name'
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'employee_name_'
        }
      }
    },
    {
      field: "entity.employee.employee_config.email",
      header: I18n.t("activerecord.attributes.laboral/employee_config.email"),
      body: (row) => row?.entity.employee?.employee_config?.email || I18n.t('no_entry'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el email del empleado',
        inputType: 'text',
        filterrific: {
          search: 'search_by_employee_email'
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'employee_email_'
        }
      }
    },
    {
      field: "entity.company.company_config.name",
      header: `${I18n.t("activerecord.attributes.laboral/hiring.company")}`,
      filter: {
        enabled: true,
        placeholder: 'Ingrese el nombre de la empresa',
        inputType: 'simple_select',
        options: _.map(companies, company => ({
          value: company.id,
          label: company.name,
        })),
        filterrific: {
          search: 'by_company'
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'company_name_'
        }
      }
    },
    {
      field: "entity.branch.name",
      header: `${I18n.t("activerecord.attributes.laboral/hiring_config.branch_id")}`,
      filter: {
        enabled: true,
        placeholder: 'Seleccione la sucursal',
        inputType: 'simple_select',
        options: _.map(branches, branch => ({
          value: branch.id,
          label: branch.name,
        })),
        filterrific: {
          search: 'by_branch'
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'branch_name_'
        }
      }
    },
    {
      field: "entity.active_to_s",
      header: `Estado de Contratación`,
      filter: {
        enabled: true,
        placeholder: 'Seleccione un estado de contratación',
        inputType: 'simple_select',
        options: hiringStateOptions,
        filterrific: {
          search: 'by_hiring_state'
        }
      },
    },
    {
      field: "entity.start_date_to_s",
      header: `${I18n.t("activerecord.attributes.laboral/hiring.start_date")}`,
      filter: {
        enabled: true,
        placeholder: 'Ingrese la fecha de inicio de la contratación',
        inputType: 'text',
        filterrific: {
          search: 'search_by_hiring_start_date'
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'start_date_'
        }
      }
    },
    {
      field: "entity.end_date_to_s",
      header: `${I18n.t("activerecord.attributes.laboral/hiring.end_date")}`,
      body: (row) => row?.entity.end_date_to_s || 'indefinido',
      filter: {
        enabled: true,
        placeholder: 'Ingrese la fecha de fin de la contratación',
        inputType: 'text',
        filterrific: {
          search: 'search_by_hiring_end_date'
        }
      },
    },
    {
      field: "document_type.name",
      header: `${I18n.t("activerecord.attributes.laboral/hiring_document.document_type")}`,
      filter: {
        enabled: true,
        placeholder: 'Seleccione un tipo de documento',
        inputType: 'simple_select',
        options: _.map(documentTypes, document_type => ({
          value: document_type.id,
          label: document_type.name,
        })),
        filterrific: {
          search: 'by_document_type'
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'document_type_name_'
        }
      }
    },
    {
      field: "label",
      header: `${I18n.t("activerecord.attributes.laboral/hiring_document.label")}`,
      body: (row) => row?.label || I18n.t('no_entry'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el nombre del documento',
        inputType: 'text',
        filterrific: {
          search: 'search_by_label'
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'label_'
        }
      }
    },
    {
      field: "aasm_state",
      header: `${I18n.t("activerecord.attributes.laboral/hiring_document.aasm_state.one")}`,
      body: (row) => I18n.t(`activerecord.attributes.laboral/hiring_document.aasm_state.${row.aasm_state}`),
      filter: {
        enabled: true,
        placeholder: 'Seleccione un estado de documento',
        inputType: 'simple_select',
        options: _.map(documentStates, documentState => ({
          value: documentState.value,
          label: documentState.label,
        })),
        filterrific: {
          search: 'by_aasm_state'
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'aasm_state_'
        }
      }
    },
    {
      field: "created_at_to_s",
      header: `${I18n.t("activerecord.attributes.laboral/hiring_document.created_at")}`,
      filter: {
        enabled: true,
        placeholder: 'Ingrese la fecha de creación del documento',
        inputType: 'text',
        filterrific: {
          search: 'search_by_created_at'
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'created_at_to_s_'
        }
      }
    }
  ]

  const tableColumnSecurityLayer = useMemo(() => {
    if (currentCustomer.security_layer && securityLayers?.length > 0) {
      return {
        field: 'entity.employee.security_layer.name',
        header: I18n.t("activerecord.attributes.laboral/employee.security_layer_id"),
        body: (row) => row?.entity.employee?.security_layer?.name || I18n.t('no_entry'),
        filter: {
          enabled: true,
          placeholder: 'Seleccione una capa de seguridad',
          inputType: 'simple_select',
          options: _.map(securityLayers, securityLayer => ({
            value: securityLayer.id,
            label: securityLayer.name,
          })),
          filterrific: {
            search: 'by_employee_security_layer_id'
          }
        }
      }
    }
  })

  const tableColumnsCustomFields = useMemo(() => {
    return _.map(customFields, function (customField) {
      return {
        field: `custom_fields.${ customField.code }`,
        header: _.capitalize(customField.label),
        body: (row) => {
          return fetchCustomFieldValue(customField, row.entity?.custom_fields?.[customField.code], currentUser)
        },
        filter: {
          enabled: isAuthorizedCustomFieldToUser(customField, currentUser),
          placeholder: `Ingrese ${ _.capitalize(customField.label) }`,
          filterrific: {
            search: `search_by_key_custom_fields`,
            searchKey: customField.code
          }
        },
        configuration: {
          isCustomField: true
        }
      }
    })
  }, [customFields])

  const tableColumns = useMemo(() => {
    let columns = _.concat(
      tableColumnSecurityLayer,
      tableColumnsDefault,
      tableColumnsCustomFields
    )

    return _.compact(columns)
  }, [])

  return (
    <Row>
      <Col md="12">
        <BulkRequestDestroyDocumentTable
          bulkRequest={bulkRequest}
          setBulkRequest={setBulkRequest}
          dataTableConfiguration={{
            columns: tableColumns
          }}
          configuration={{
            context: 'laboral',
            defaultRequestParams: {},
            showDistributionListFilter: false,

          }}
          routes={{
            indexDocumentsPath: Routes.laboral_hiring_documents_path,
            indexBulkRequestPath: Routes.laboral_bulk_request_destroy_documents_path,
            showBulkRequestPath: Routes.laboral_bulk_request_destroy_document_path,
          }}
          services={{
            createService: createBulkRequestDestroyDocumentService,
          }}
        />
      </Col>
    </Row>
  );
}

export default LaboralBulkRequestDestroyDocumentForm;
